import { useInsightsDate } from '@services/InsightsDateProvider';
import { useShop } from '@services/ShopProvider';

import * as Stats from '@components/StatsCard';
import OrganicVisibilityContent from '@components/OrganicVisibilityContent';
import InsightCardContainer from '../InsightCardContainer';

import styles from './OrganicVisibilityCard.module.scss';

const OrganicVisibilityCard = ({ options: propOptions, shopIds: propShopIds }) => {
	const { selectedRange } = useInsightsDate();
	const { data: shops } = useShop();

	const shopIds = propShopIds || shops.map((shop) => shop.id);
	const options = propOptions || {
		dataLabels: true,
		referenceLines: true,
		summaryView: false
	};

	return (
		<InsightCardContainer>
			<Stats.Title>
				<span>Organic visibility impact</span>
			</Stats.Title>
			<Stats.Subtitle>{selectedRange}</Stats.Subtitle>
			<div className={styles.content}>
				<OrganicVisibilityContent options={options} shopIds={shopIds} />
			</div>
		</InsightCardContainer>
	);
};

export default OrganicVisibilityCard;
